import { getContainRect } from '../../utils/geometry';

export { getContainRect };

/** YouTube-recommended channel art size */
export const CANVAS_WIDTH = 2560;
export const CANVAS_HEIGHT = 1440;

/** YouTube-accepted channel art file size */
export const YOUTUBE_MAX_FILE_BYTES = 6 * 1024 * 1024;

/** YouTube safe zones (all centered within 2560 × 1440) */
export const DESKTOP_SAFE_WIDTH = 2560;
export const DESKTOP_SAFE_HEIGHT = 423;
export const TABLET_SAFE_WIDTH = 1855;
export const TABLET_SAFE_HEIGHT = 423;
export const MOBILE_SAFE_WIDTH = 1546;
export const MOBILE_SAFE_HEIGHT = 423;

const stripTop = (CANVAS_HEIGHT - DESKTOP_SAFE_HEIGHT) / 2 / CANVAS_HEIGHT;
const stripBottom = (CANVAS_HEIGHT + DESKTOP_SAFE_HEIGHT) / 2 / CANVAS_HEIGHT;

/** Fractional positions of each safe zone within the banner */
export const SAFE_ZONE = {
  tv: {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
  },
  desktop: {
    left: 0,
    right: 1,
    top: stripTop,
    bottom: stripBottom,
  },
  tablet: {
    left: (CANVAS_WIDTH - TABLET_SAFE_WIDTH) / 2 / CANVAS_WIDTH,
    right: (CANVAS_WIDTH + TABLET_SAFE_WIDTH) / 2 / CANVAS_WIDTH,
    top: (CANVAS_HEIGHT - TABLET_SAFE_HEIGHT) / 2 / CANVAS_HEIGHT,
    bottom: (CANVAS_HEIGHT + TABLET_SAFE_HEIGHT) / 2 / CANVAS_HEIGHT,
  },
  mobile: {
    left: (CANVAS_WIDTH - MOBILE_SAFE_WIDTH) / 2 / CANVAS_WIDTH,
    right: (CANVAS_WIDTH + MOBILE_SAFE_WIDTH) / 2 / CANVAS_WIDTH,
    top: (CANVAS_HEIGHT - MOBILE_SAFE_HEIGHT) / 2 / CANVAS_HEIGHT,
    bottom: (CANVAS_HEIGHT + MOBILE_SAFE_HEIGHT) / 2 / CANVAS_HEIGHT,
  },
} as const;


/** Centered 1546×423 safe zone in dest-canvas pixels. */
export function getSafeZoneRect(destW: number, destH: number): {
  x: number;
  y: number;
  width: number;
  height: number;
} {
  return {
    x: SAFE_ZONE.mobile.left * destW,
    y: SAFE_ZONE.mobile.top * destH,
    width: (SAFE_ZONE.mobile.right - SAFE_ZONE.mobile.left) * destW,
    height: (SAFE_ZONE.mobile.bottom - SAFE_ZONE.mobile.top) * destH,
  };
}

/** Contain the image inside the mobile/safe zone of a dest canvas (Fit mode). */
export function getFitImageRect(
  destW: number,
  destH: number,
  imgW: number,
  imgH: number,
): { x: number; y: number; width: number; height: number } | null {
  const zone = getSafeZoneRect(destW, destH);
  const inner = getContainRect(zone.width, zone.height, imgW, imgH);
  if (!inner) return null;
  return {
    x: zone.x + inner.x,
    y: zone.y + inner.y,
    width: inner.width,
    height: inner.height,
  };
}
